import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { candidatePortalApi } from '../../api/candidatePortal';
import { useCandidateAuth } from './CandidateAuthContext';
import { CareersNav } from './CareersNav';

export function CareersLoginPage() {
  const { refresh } = useCandidateAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') || '/careers/my-applications';
  const [error, setError] = useState<string | null>(null);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<{ email: string; password: string }>();

  const onSubmit = async (values: { email: string; password: string }) => {
    setError(null);
    try {
      await candidatePortalApi.login(values);
      await refresh();
      navigate(nextPath);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to sign in.');
    }
  };

  return (
    <div className="careers-page">
      <CareersNav />
      <div className="card" style={{ maxWidth: 420, margin: '24px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Sign In</h1>
        <p className="muted">Access your Verdantrise candidate account.</p>
        {error && <p className="field-error">{error}</p>}
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>Email<input type="email" {...register('email', { required: true })} /></label>
          <label>Password<input type="password" {...register('password', { required: true })} /></label>
          <div className="form-actions"><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Signing in…' : 'Sign In'}</button></div>
        </form>
        <p className="muted">Don't have an account? <Link to={`/careers/signup${nextPath !== '/careers/my-applications' ? `?next=${encodeURIComponent(nextPath)}` : ''}`}>Create one</Link></p>
      </div>
    </div>
  );
}
